import React from 'react';
import './Headeraide.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Headeraide() {
  return (
    <div>
    <div className='main2aidesocial'>
    <div className="boutton-container1aidesocial">
        <div className='buts aidesocial'>
            <button className="boutton2aidesocial">
                SERVICE SOCIAL<ArrowForwardIcon className="arrow-iconaidesocial" />AIDE SOCIALE
            </button>
            <h1 className="aidesocial1">AIDE SOCIALE</h1>
        </div>
    </div>
</div>

    </div>
  );
}

export default Headeraide;
